import { PayoutInput, PayoutResponse } from "../../types/Payout";
import {
    getPayoutsAdminResponse,
    PayoutsAdminSortBy,
} from "../../types/api/admin/payouts";
import { request } from "../apiService";

export const getPayoutsByUser = async (
    userId: string,
    startDate: string,
    endDate: string
) => {
    return await request<PayoutResponse>(
        `/payouts/user/${userId}?start=${startDate}&end=${endDate}`
    );
};

export const createPayout = async (input: PayoutInput) => {
    return await request<PayoutResponse, PayoutInput>("/payouts", {
        method: "POST",
        input,
    });
};

export const updatePayout = async (id: string, input: PayoutInput) => {
    return await request<PayoutResponse, PayoutInput>(`/payouts/${id}`, {
        method: "PUT",
        input,
    });
};

export const deletePayout = async (id: string) => {
    return await request<boolean>(`/payouts/${id}`, {
        method: "DELETE",
    });
};

export const createAdminPayout = async (userId: string, input: PayoutInput) => {
    return await request<PayoutResponse, { userId: string } & PayoutInput>(
        "/v2/admin/payouts",
        {
            method: "POST",
            input: { userId, ...input },
        }
    );
};

export const getAdminPayouts = async (
    search: string,
    startDate: string,
    endDate: string,
    sortBy: PayoutsAdminSortBy,
    sortOrder: "asc" | "desc",
    showNoPayouts: boolean = false,
    fundingStatusFilter?: "" | "funded" | "not_funded"
) => {
    return await request<
        getPayoutsAdminResponse,
        {
            search: string;
            startDate: string;
            endDate: string;
            sortBy: PayoutsAdminSortBy;
            sortOrder: "asc" | "desc";
            showNoPayouts: boolean;
            fundingStatusFilter?: "" | "funded" | "not_funded";
        }
    >("/v2/admin/payouts", {
        input: {
            search,
            startDate,
            endDate,
            sortBy,
            sortOrder,
            showNoPayouts,
            ...(fundingStatusFilter ? { fundingStatusFilter } : {}),
        },
    });
};
